import React from 'react';
import { Link, TableCell, Typography } from '@mui/material';
import type { LlmUsageSummary } from '../apis/observerApi';

export const formatUsageTokens = (value: number | null) => value == null ? '—' : value.toLocaleString();
export const formatUsageCost = (value: number | null) => value == null ? '—' : new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', minimumFractionDigits: 4, maximumFractionDigits: 6,
}).format(value);

export function formatUsageDuration(milliseconds: number | null) {
  if (milliseconds == null) return '—';
  const seconds = milliseconds / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  const minutes = Math.floor(seconds / 60);
  return `${minutes}m ${(seconds % 60).toFixed(1)}s`;
}

export function UsageCostCell({ usage, onClick }: { usage: LlmUsageSummary; onClick?: () => void }) {
  const value = <>{formatUsageCost(usage.total_cost)}{usage.unpriced_count > 0 ? ' (partial)' : ''}</>;
  return <TableCell align="right">
    {onClick ? <Link component="button" type="button" onClick={event => { event.stopPropagation(); onClick(); }}
      aria-label="View token usage and cost" sx={{ font: 'inherit' }}>{value}</Link> : value}
  </TableCell>;
}

export function UsageTotals({ usage }: { usage: LlmUsageSummary }) {
  return <Typography variant="body2" sx={{ my: 1 }}>
    Input tokens: <strong>{formatUsageTokens(usage.input_tokens)}</strong>
    {' · '}Output tokens: <strong>{formatUsageTokens(usage.output_tokens)}</strong>
    {' · '}Cost: <strong>{formatUsageCost(usage.total_cost)}</strong>
    {' · '}API attempts: <strong>{usage.attempt_count}</strong>
    {usage.unpriced_count > 0 && <> · {usage.unpriced_count} attempts without a cost estimate</>}
    {usage.missing_usage_count > 0 && <> · {usage.missing_usage_count} attempts with missing usage</>}
    {usage.attempt_count === 0 && <> · No recorded usage</>}
  </Typography>;
}
